<template lang="pug">
  .pos-list(v-if='posData')
    .pos-item(v-for='pos in orderedPosList' :key='pos.Id' :class="{'is-active': pos.Id === selected}" @click='setPos(pos)')
      div.pos-item__inner
        p
          span.pos-name.color-brand Cơ sở {{pos.Pos_Name}}
          span.color-secondary(v-if="pos.Distance") {{ pos.Distance>0 ? pos.Distance + 'km': pos.Distance}}
        svg(width='19' height='17' viewbox='0 0 19 17' fill='none' xmlns='http://www.w3.org/2000/svg')
          path(d='M10.7045 1.28401C10.3111 0.896392 9.678 0.901082 9.2904 1.29449C8.9027 1.68789 8.9074 2.32104 9.3008 2.70866L14.6712 8.00006H1C0.44771 8.00006 0 8.44776 0 9.00006C0 9.55236 0.44772 10.0001 1 10.0001H14.6646L9.3008 15.285C8.9074 15.6726 8.9027 16.3058 9.2904 16.6992C9.678 17.0926 10.3111 17.0973 10.7045 16.7096L17.6287 9.88716C18.1256 9.39756 18.1256 8.59596 17.6287 8.10636L10.7045 1.28401Z' fill='#ADA8A8')
</template>
<script>
  import _ from 'lodash';
  import { bus } from '../main'

  import '../assets/css/pos-list.css'

  export default {
    name: 'PosList',
    props: {
      posData: Array,
      location: Object
    },
    data () {
      return {
        selected : null,
        dis: -1,
      }
    },
    created () {

      this.parseDistances()

    },
    watch: {
      location () {
        this.parseDistances()
      }
    },
    methods: {
      async setPos(pos) {

        this.dis = pos && pos.Distance > 0 ? pos.Distance : await this.checkDistance(pos, this.location);

        if (this.dis && 12 < this.dis) {
          // mở popup báo lỗi
          bus.$emit('shipmentWarning');
          return;
        }

        this.selected = pos.Id || null;
        this.$store.dispatch('shipments/setSelecting', false)
        this.$store.dispatch('restaurants/setSelected', pos.Id)
      },
      async parseDistances() {
        if (this.posData) {
          for (let index = 0; index < this.posData.length; index++) {
            const item = this.posData[index]

            if (this.location) {

              this.$set(this.posData[index],'Distance', 'loading ...')
            } else {
              this.$set(this.posData[index],'Distance', '')
            }

            const aNew = await this.getDistance(item, this.location)
            //console.log(aNew)
            if (aNew && aNew.data && aNew.data.distance > 0) {
              this.$set(this.posData[index],'Distance', aNew.data.distance)
            }
          }
        }
      },
      getDistance(pos, location, amount = 50000) {
        if (pos && pos.Id && location && location.lng && location.lat) {
          return this.$http.get(this.$foodbookConfig.wpapi + '/ship', {
            params: {
              pos_id: pos.Id,
              pos_parent: 'SUONMUOI',
              lng: location.lng,
              lat: location.lat,
              amount: amount
            }
          }).then(({data}) => data);
        } else {
          return -1; // Không xác định
        }

      },
      checkDistance(pos, location, amount = 50000) {
        if (pos && pos.Id && pos.Pos_Parent && location && location.lng && location.lat) {
          return this.$http.get(this.$foodbookConfig.wpapi + '/ship', {
            params: {
              pos_id: pos.Id,
              pos_parent: pos.Pos_Parent,
              lng: location.lng,
              lat: location.lat,
              amount: amount
            }
          }).then(({data}) => {
            // Trả về khoảng cách
            return (data && data.data && data.data.distance) ? data.data.distance : -1;
          });
        } else {
          return -1; // Không xác định
        }

      },
    },
    computed: {
      orderedPosList() {
        return this.posData
      }
    },
  }
</script>
<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/PosList.vue